import React from 'react';
import './stylesheet.scss';

const Separator = ({ className, style = {} }) => <div className={`marketplace-classified-separator ${className || ''}`} style={style} />;

export default Separator;
